<template>
	<div

	>
		<div class="list-form-group__container">
			<div
				v-for="(checkbox, index) in checkboxes"
				:key="index"
				:class="['list-form-group__item', {'list-form-group__item--full-width': checkbox.description}]"
			>
				<checkbox
					:checkbox="checkbox"
					@click.native="clickHandler(groupName, index)"
				></checkbox>
			</div>
		</div>
	</div>
</template>

<script>
	import Checkbox from '../formFields/Checkbox.vue';

	export default {
		components: {
			Checkbox
		},
		props: {
			header: {
				type: String
			},
			groupheading: {
				type: Object,
				required: true
			},
			checkboxes: {
				type: Array,
				required: true
			},
			groupName: {
				type: String,
				required: true
			},
			clickHandler: {
				type: Function,
				required: true
			}
		}
	};
</script>

<style lang="scss" scoped>
	@import '~sass/_variables.scss';
	@import "~sass/_config.scss";
	@import "~sass/mixins/_media-query.scss";
	@import "~sass/mixins/_attr-bp.scss";

	$columnsFlexBasis: (
		default : 100%,
		mobile: 33.3333%
	);

	$bottomPadding: (
		default: 30px,
		largeMobile: 50px
	);

	.list-form-group {
		@include attr-bp($bottomPadding, 'padding-bottom');

		position: relative;

		&__container {
			display: flex;
			flex-wrap: wrap;
			justify-content: flex-start;
			margin-right: -15px;
			margin-bottom: -15px;
		}

		&__item {
			@include attr-bp($columnsFlexBasis, 'flex-basis');
			@include attr-bp($columnsFlexBasis, 'max-width'); // IE fix

			padding-right: 15px;
			margin-bottom: 15px;
			flex-grow: 0;
			flex-shrink: 0;

			&--full-width {
				flex-basis: 100%;
				max-width: 100%; // IE fix
			}
		}

		&::after {
			content: '';
			position: absolute;
			top: 0;
			right: 0;
			bottom: 0;
			left: 0;
			background-color: $col-neutral--0;
			opacity: 0;
			visibility: hidden;
			transition-property: opacity, visibility;
			transition-duration: $ttime;
			transition-delay: 0ms, $ttime;
		}

		&.is-disabled {
			pointer-events: none;

			&::after {
				visibility: visible;
				opacity: 0.6;
				transition-delay: 0ms, 0ms;
			}
		}
	}
</style>